<template>
  <div v-loading="loading"
       class="other-account"
       page_id="page_tradeAccount">
    <div v-show="loading===false">
      <bCardHeader :param="param"></bCardHeader>

      <el-row :gutter="30">
        <el-col :xs="24"
                :sm="24"
                :md="12"
                :lg="12"
                :xl="12">
          <keep-alive>
            <component v-bind:is="currentTabComponent"
                       :accountData="accountData"
                       @goOpenPage="goOpenPage"></component>
          </keep-alive>
        </el-col>
        <el-col :xs="24"
                :sm="24"
                :md="12"
                :lg="12"
                :xl="12"
                class="apply-records p-0-m">
          <apply-record :threeListData="threeListData"></apply-record>
        </el-col>
      </el-row>
      <el-dialog :title="title"
                 :visible.sync="dialogVisible"
                 width="30%"
                 class="fund-box"
                 :before-close="handleClose"
                 :close-on-click-modal="false">
        <div class="top-info"
             v-html="$t('fund.fundTarget')"></div>
        <div class="title">{{$t('fund.warnText')}}</div>
        <div class="content">{{$t('fund.importText')}}</div>
        <div class="btn-box">
          <div class="top"
               @click="toRiskHandle">{{$t('fund.toRisk')}}</div>
          <!-- <div class="bottom"
               @click="toDisclosureHandle">{{$t('fund.toOpenaccount')}}</div> -->
        </div>
      </el-dialog>
      <el-dialog :title="$t('quotes.addressTips.tips')"
                 :visible.sync="popupVisible"
                 width="30%"
                 class="fund-box"
                 :before-close="handlePopClose"
                 :close-on-click-modal="false">
        {{$t('applyTradeAccount.notAccount')}}
        <div class="btn-box btn-box-one">
          <div class="top"
               @click="handlePopClose">{{$t('common.ok')}}</div>
        </div>
      </el-dialog>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import applyCard from './components/applyCard'
import applyRecord from './components/applyRecord'
import api from '@/api/v2/trade'
import { riskStatus } from '@/api/v2/fund'
import _ from 'lodash'
export default {
  name: 'other-account',
  computed: {
    ...mapGetters([
      'getUser',
      'selectLang',
      'getAccountInfo',
      'getClientProfile'
    ]),
    ...mapState(['userInfo'])
  },
  components: {
    applyCard,
    applyRecord
  },
  data() {
    return {
      param: {
        title: 'other_account',
        links: [
          {
            title: 'home'
          },
          {
            title: 'my_account'
          },
          {
            title: 'other_account'
          }
        ]
      },
      loading: false,
      threeListData: [],
      canClick: false,
      accountData: [],
      currentTabComponent: 'applyCard',
      dialogVisible: false,
      title: this.$t('fund.applyFund'),
      riskStatus: '',
      agreement: false,
      popupVisible: false,
      isPopup: false
    }
  },
  created() {
    let curLang = sessionStorage.getItem('language')
      ? sessionStorage.getItem('language')
      : 'cn'
    this.$store.dispatch('selectLang', curLang)
  },
  async mounted() {
    this.getApplyTradeAccountType()
    this.getApplyRecord()
    this.getRiskStatus()
    this.verifyAccount()
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },
    handlePopClose() {
      this.popupVisible = false
    },
    translate(type) {
      return this.$t('applyTradeAccount.' + type.toLowerCase())
    },
    translateTradeAccountType(tradeAccountType) {
      return this.$t('tradeAccountType.' + tradeAccountType)
    },
    /**
     * 获取三条申请记录
     */
    async getApplyRecord() {
      try {
        let params = {
          submitSource: 'CP_WEB'
        }
        let result = await api.getTradeAccountRecord(params)
        let data = result.data ? result.data : []
        this.threeListData = data.filter(item => {
          return item.accountType !== 'VA'
        })
        this.loading = false
      } catch (error) {
        console.log('>>>>>getApplyRecord', error)
        this.loading = false
        this.$message.error(
          this.$t('errorTips.otherAccount.getApplyRecordError')
        )
      }
    },
    /**
     * 获取申请账号信息
     */
    async getApplyTradeAccountType() {
      try {
        this.loading = true
        let params = {
          submitSource: 'CP_WEB'
        }
        let { data } = await api.getTradeAccountInfo(params)
        this.loading = false
        // // 基金账户只显示已开通的
        // let filterData = data.filter(item => {
        //   return !(item.tradeAccountType === 'FUND_CASH' && item.status !== 'OPEN')
        // })
        data = data.map(item => {
          item._tradeAccountType = item.tradeAccountType
          item.tradeAccountType = item.tradeAccountType
            .toLowerCase()
            .replace(/_[a-z]/g, function(m) {
              return m.slice(1).toUpperCase()
            })
          // item.type = changeTradetypeToType(item.tradeAccountType)
          return item
        }) || []
        // 过滤SP交易账号
        if (this.userInfo.isSPAccount === 'Y') {
          this.accountData = data.filter((item) => {
            // item.isDormant = true
            return !(item.tradeChannel === 'SP' && ['OPEN', 'STOP'].includes(item.status))
          })
        } else {
          this.accountData = data
        }
      } catch (err) {
        console.log('>>>>>applyTradeAccountTypeList', err)
        this.loading = false
        this.$message.error(
          this.$t('errorTips.otherAccount.applyTradeAccountTypeListError')
        )
      }
    },
    goOpenPage: _.debounce(async function (params) {
      const preCheckResult = await api.getPreCheckResult({ accountType: params._tradeAccountType })
        // 申请开通交易账户前检查
      if (preCheckResult.code && preCheckResult.code !== 200) {
        return this.$message.error(preCheckResult.msg)
      }
      this.popupVisible = this.isPopup
      if (this.popupVisible) {
        return
      }
      if (params.type === 'FUND') {
        // 先开通证券账户才可开通基金账户
        let stock = this.accountData.filter(item => {
          return item.type === 'STOCK' && item.status === 'OPEN'
        })
        if (!stock.length) {
          return this.$message.error(this.$t('fund.openStock'))
        }
        // 做了风险测评 未确认风险测评
        // if (this.riskStatus && !this.agreement) {
        //   this.$router.push({
        //     path: '/risk-level'
        //   })
        //   return
        // }
        // 做了风险测评 已确认风险测评
        if (this.riskStatus && this.agreement) {
          this.$router.push({
            path: '/risk-disclosure'
          })
          return
        }
        // this.dialogVisible = true
        this.$router.push({
          path: '/risk-tip'
        })
        return
      }
      let query = {
        type: params.type,
        tradeAccountType: params._tradeAccountType,
        status: params.status,
        remark: '',
        tradeAccountNumber: params.tradeAccountNumber
      }
      if (params.status === 'REJECT') {
        query.remark = params.remark
      }

      this.$router.push({
        path: '/account-application',
        query: query
      })
    }, 500, { leading: true, trailing: false }),
    toRiskHandle() {
      this.$router.push({
        path: '/risk-tip'
      })
    },
    toDisclosureHandle() {
      this.$router.push({
        path: '/risk-disclosure'
      })
    },
    // 获取基金风险测评状态
    async getRiskStatus() {
      let res = await riskStatus()
      if (res && res.code === 200) {
        this.riskStatus = res.data.status
        this.agreement = res.data.agreement
      }
    },
    async verifyAccount() {
      let res = await api.verifyAccount()
      if (res && res.code === 200) {
        this.isPopup = res.data.isPopup
      }
    }
  }
}
</script>

<style lang="scss">
.other-account {
  .noapply-records-list {
    height: 348px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #7d7d7d;
    font-size: 12px;
    text-align: left;
    font-family: PingFangTC-Regular;
  }

  .el-card__body {
    padding: 20px 20px 14px;
  }

  .origin,
  .review-failure {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    border: 1px solid #e2e2e2;
    padding: 30px 0;
    margin-bottom: 20px;
    border-radius: 10px;
    color: #666666;
    .line1 {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
    }
  }

  .reviewing {
    background: #f3f4f6;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    border: 1px solid #e2e2e2;
    padding: 30px 0;
    border-radius: 10px;
    color: #666666;

    .line1 {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
    }
  }

  .review-success {
    background: #f3f4f6;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    border: 1px solid #e2e2e2;
    padding: 30px 0;
    border-radius: 5px;
    color: #666666;
    position: relative;
    .line1 {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        margin-right: 10px;
      }
    }

    .line2 {
      margin-top: 10px;
      font-size: 16px;
    }
  }

  .application {
    position: absolute;
    top: 0;
    right: 11px;
    height: 70px;
    width: 70px;
  }
}
</style>
<style lang="scss" scoped>
.fund-box {
  /ddep/.el-dialog {
    max-height: 800px;
    border-radius: 5px !important;
  }
  /deep/ .el-dialog__header {
    padding: 25px 30px 22px;
  }
  /deep/ .el-dialog__headerbtn {
    right: 30px;
    font-size: 18px;
  }
  /deep/ .el-dialog__title {
    font-size: 18px;
    font-weight: 500;
    color: #182a54;
    line-height: 22px;
  }
  /deep/ .el-dialog__body {
    padding: 0 30px 30px;
    color: #7d7d7d;
  }
}

.top-info {
  font-size: 15px;
  font-weight: 400;
  color: #24282d;
  line-height: 23px;
  margin-bottom: 26px;
}
.title {
  font-size: 16px;
  font-weight: 600;
  color: #24282d;
  line-height: 22px;
  margin-bottom: 10px;
}
.content {
  font-size: 14px;
  font-weight: 400;
  color: #868e9e;
  line-height: 21px;
  background: #f9fbff;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 30px;
}
.btn-box {
  font-size: 14px;
  font-weight: 600;
  color: #193060;
  line-height: 20px;
  width: 50%;
  margin: auto;
  text-align: center;

  .top {
    background: #fec000;
    border-radius: 5px;
    padding: 15px 0;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .bottom {
    border-radius: 5px;
    border: 1px solid #193060;
    padding: 15px 0;
    cursor: pointer;
  }
}
.btn-box-one {
  padding-top: 30px;
  .top {
    margin-bottom: 0;
  }
}
</style>
